define('views/modules/calendar/animated-session/tags/manager/exercises/tag-exercise-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/menu/menu',
    'views/parts/menu/menu-context',
    // templates
    'text!templates/modules/calendar/animated-session/animation/lists/animation-list-item.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VMenu,
    VMenuContext,
    // templates
    TExerciseAnimationItem
) {

    var VTagExerciseListItem = Backbone.View.extend({
        template: TExerciseAnimationItem,
        events: {
            "click .options-toggle": "onMenuOptionToggle",
        },

        regions: {
            item: ".animation-box",
            menu: ".menu-options",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.view = {};

            this.listenTo(this.model, 'remove', this.remove);
        },

        render: function() {
            var $html = Backbone.$(Mustache.render(this.template, Mustache.getContext(this.model.toJSON())));

            this.$el.replaceWith($html);
            this.setElement($html);

            this.generateZones();

            return this;
        },

        /////////////
        // actions //
        /////////////
        onDetailAction: function(e, item) {
            this.model.trigger("animation:detail", this.model);
        },

        onDeleteAction: function(e, item) {
            this.model.trigger("animation:remove", this.model);
        },

        ////////////
        // events //
        ////////////

        onMenuOptionToggle: function(e) {
            e.preventDefault();

            if (!this.view.menu) {
                this.menuCollection = new Backbone.Collection([
                    { caption: 'View details', icon: "sl-icon-list", callback: this.onDetailAction },
                    { caption: 'Delete', icon: "sl-icon-minus", callback: this.onDeleteAction }
                ]);
                // edit isn't available on yourself

                this.listenTo(this.menuCollection, "item:click", this.onActionClick);
                this.view.menu = new VMenuContext({
                    collection: this.menuCollection,
                    context: this
                });
                this.assign(this.view.menu, this.zone.$menu);
            }
            this.view.menu.toggle();
        },

        onActionClick: function(e, optionModel) {
            e.preventDefault();
            e.stopPropagation();
        },

    });

    return VTagExerciseListItem;

});

